var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"l-autobuyer-singlet-group"},[_vm._l((_vm.singles),function(type,id){return [_c('SingleAutobuyerBox',{key:id,style:(_vm.boxSize),attrs:{"autobuyer":type}}),(id % _vm.entryCountPerRow === _vm.entryCountPerRow)?_c('br',{key:id}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }